import { AbstractControl, ValidationErrors, AsyncValidatorFn } from '@angular/forms';
import { Observable, of, timer } from 'rxjs';
import { map, take, catchError, switchMap } from 'rxjs/operators';
import { GeoValidationService } from '../services/geo-validation.service';

/**
 * AsyncValidator que comprueba contra el backend si la coordenada
 * (lat, lng) cae dentro del polígono del municipio identificado por cityId.
 *
 * Se aplica idealmente sobre el FormGroup del bloque "address" cuyo valor
 * tiene la forma:
 *
 *   { cityId: string, lat: number, lng: number }
 *
 * Cuando alguno de esos campos no está presente, el validator no se ejecuta
 * (devuelve null) — los validadores síncronos (Validators.required) se
 * encargan del caso "vacío".
 *
 * Errores devueltos:
 *   { outsideMunicipality: { message, municipalityName, departmentName, reason, distanceMeters } }
 *
 * Uso típico:
 *
 *   addressGroup.setAsyncValidators(
 *     municipalityPolygonValidator(this.geoValidation, () => ({
 *       cityId: this.cityControl.value && this.cityControl.value.id,
 *       lat: this.locationControl.value && this.locationControl.value.lat,
 *       lng: this.locationControl.value && this.locationControl.value.lng,
 *     }))
 *   );
 */
export function municipalityPolygonValidator(
  geoValidation: GeoValidationService,
  resolveInput: () => { cityId: string, lat: number, lng: number } | null
): AsyncValidatorFn {
  return (_control: AbstractControl): Observable<ValidationErrors | null> => {
    const input = resolveInput();
    if (!input || !input.cityId || input.lat == null || input.lng == null) {
      console.log('[MunicipalityValidator] skip (input incompleto)', input);
      return of(null);
    }
    console.log('[MunicipalityValidator] disparado', input);
    return timer(150).pipe(
      switchMap(() => geoValidation.validate(input)),
      map(resp => {
        if (resp.valid) {
          console.log('[MunicipalityValidator] OK', resp.municipalityName);
          return null;
        }
        const err = {
          outsideMunicipality: {
            message: resp.message,
            municipalityName: resp.municipalityName,
            departmentName: resp.departmentName,
            reason: resp.reason,
            distanceMeters: resp.distanceToBoundaryMeters
          }
        } as ValidationErrors;
        console.warn('[MunicipalityValidator] form.errors.outsideMunicipality =', err.outsideMunicipality);
        return err;
      }),
      catchError(err => {
        console.warn('[MunicipalityValidator] error -> no bloquea (degradación graciosa)', err);
        return of(null);
      }),
      take(1)
    );
  };
}
